import { useEffect, useRef, useState } from 'react';
import { vehicleListApi, createListRequestGuard } from '../api/vehicleListApi';
import { toRequestParams } from './vehicleListQuery';

const emptyAggregates = {
  matching: 0,
  active: 0,
  tyre_management_enabled: 0,
  tyre_unconfigured: null,
};

const useVehicleListData = (query, refreshKey = 0) => {
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [aggregates, setAggregates] = useState(emptyAggregates);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState('');
  const loadedRef = useRef(false);
  const guardRef = useRef(createListRequestGuard());

  useEffect(() => {
    const guard = guardRef.current;
    const { id, signal } = guard.next();
    if (loadedRef.current) setUpdating(true);
    else setLoading(true);
    setError('');

    vehicleListApi.getList(toRequestParams(query), { signal })
      .then((result) => {
        if (!guard.isCurrent(id)) return;
        setRows(result?.results || []);
        setCount(result?.count || 0);
        setAggregates(result?.aggregates || emptyAggregates);
        loadedRef.current = true;
      })
      .catch((requestError) => {
        if (requestError.aborted || !guard.isCurrent(id)) return;
        setError(requestError.message);
        if (!loadedRef.current) setRows([]);
      })
      .finally(() => {
        if (!guard.isCurrent(id)) return;
        setLoading(false);
        setUpdating(false);
      });

    return () => guard.abort();
  }, [query, refreshKey]);

  return {
    rows,
    count,
    aggregates,
    loading,
    updating,
    error,
  };
};

export default useVehicleListData;
